'use es6';

import logFailedAction from 'AdsUI/lib/logFailedAction';
export default (() => next => action => {
  const {
    type
  } = action;
  const errors = action.payload && (action.payload.errors || action.payload.accountErrors);

  if (type.indexOf('_FAILED') > -1) {
    logFailedAction(action);
  } else if (errors && errors.length) {
    logFailedAction(action);
  }

  return next(action);
});